import React, { Component } from 'react';
import { put } from '../Services/http';
import { translate } from '../Services/translation';

class InsiderRegistration extends Component {
    constructor(props) {
        super(props);

        this.state = this.getInitialState();
        
    }

    componentDidMount() {
        this.setConsent(false);
    }

    getInitialState() {
        return {
            expanded: false,
            isError: false,
            gdprChecked: false,
            passwordsNotValid: false,
            firstPassword: "",
            secondPassword: "",
            gender: "Male"
        }
    }

    verifyPasswordInput(invalidPasswords) {
        this.setState({ passwordsNotValid: invalidPasswords });
        return !invalidPasswords;
    }

    bothPasswordsEmpty() {
        return this.state.firstPassword === "" && this.state.secondPassword === "";
    }

    passwordsNotEqual() {
        return this.state.firstPassword !== this.state.secondPassword;
    }

    onInputChanged(event) {
        this.setState({ [event.target.name]: event.target.value }, 
            () => this.verifyPasswordInput(this.passwordsNotEqual()))

        if (this.state.gdprChecked) {
            this.setState({gdprChecked: false}, () => this.setConsent(false))
        }
    }

    setGdprChecked(checked) {
        if (!this.verifyPasswordInput(this.bothPasswordsEmpty() || this.passwordsNotEqual())) {
            return;
        }

        this.setConsent(checked);
    }

    getIsGdprChecked() {
        return this.state.gdprChecked;
    }

    setConsent(consent) {
        put('/api/checkout/cacheInsiderData', {
            password: consent ? this.state.firstPassword : '',
            gender: this.state.gender,
            consents: consent
        })
        .then(response => {
            this.setState({gdprChecked: consent, isError: false})
        })
        .catch(ex => { 
            this.setState({isError: true})
        })
    }

    expandAccordion() {
        this.setState({ expanded: !this.state.expanded })
    }

    render() {
        const payload = this.props.checkout.payload

        return (
            <div id="insider-section" className="row">
                <div className="columns">
                    <div id="insider-accordion">
                        <div onClick={() => this.expandAccordion()} id="insider-header-container" className="row">
                            <div className="columns small-1"><div className="insider-header-profile-icon"/></div>
                            <div className="columns">{translate('checkout.insider.header')}</div>
                            <div className="columns small-2">
                                <div className={`accordion-header-expand-icon ${this.state.expanded ? "expanded" : ""}`}></div>
                            </div>
                        </div>
                        <div dangerouslySetInnerHTML={{__html: payload.insiderInfoText}} id="insider-description-container" className={`row text-thin ${!this.state.expanded ? "hidden" : ""}`}>
                        </div>
                        <div id="insider-input-container" className={`row ${!this.state.expanded ? "hidden" : ""}`}>
                            <div className="columns insider-input">
                                <label htmlFor="insider-preferred-gender">{translate('checkout.insider.genderpreference')}</label>
                                <select name="gender" onChange={(event) => this.onInputChanged(event)}>
                                    <option value="Female">{translate('gender.female')}</option>
                                    <option value="Male">{translate('gender.male')}</option>
                                    <option value="Both">{translate('gender.both')}</option>
                                </select>
                            </div>
                            <div className="columns insider-input">
                                <label htmlFor="insider-preferred-gender">{translate('checkout.insider.password')}</label>
                                <input type="password" name="firstPassword" id="insider-first-password" 
                                    onChange={(event) => this.onInputChanged(event)}
                                    className={`form__input ${this.state.passwordsNotValid ? "invalidinput" : ""}`}
                                    />
                            </div>
                            <div className="columns insider-input">
                                <label htmlFor="insider-preferred-gender">{translate('checkout.insider.confirmpassword')}</label>
                                <input type="password" name="secondPassword" id="insider-confirmed-password" 
                                    onChange={(event) => this.onInputChanged(event)}
                                    className={`form__input ${this.state.passwordsNotValid ? "invalidinput" : ""}`}
                                    />
                            </div>
                        </div>
                        <div id="insider-gdpr-container" className={`row ${!this.state.expanded ? "hidden" : ""}`}>
                            <div>
                                <input className="" type="checkbox" id="insider-gdpr" onChange={(event) => this.setGdprChecked(event.target.checked)} checked={this.getIsGdprChecked()}/>
                                <label dangerouslySetInnerHTML={{__html: payload.gdprCheckBoxText}} htmlFor="insider-gdpr"></label>
                            </div>
                            <div>
                                <span id="input-error" className="form__validator--error" data-error-for="gdpr-check">
                                    { this.state.isError && 'Error' }
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default InsiderRegistration;